import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import { Button } from "@wise-emotions/react-button";
import React, { ReactNode } from "react";

export type CardPromoCta =
  | { variant: "no-cta" }
  | { variant: "button"; ctaLabel: string; onCtaClick: VoidFunction }
  | {
      variant: "link";
      ctaLabel: string;
      ctaAnchor: (children: ReactNode) => JSX.Element;
    };

export type Props = {
  title: string;
  description?: ReactNode;
  badgeLabel?: string;
  disclaimer?: ReactNode;
} & CardPromoCta;

const CardPromo = ({
  badgeLabel,
  title,
  description,
  disclaimer,
  ...props
}: Props) => {
  const wrapper = (children: ReactNode) =>
    "ctaAnchor" in props ? props.ctaAnchor(children) : children;

  return (
    <>
      <div className="card-promo">
        {badgeLabel && (
          <div>
            <Badge
              variant="iconAndLabel"
              theme="promo-inverse"
              label={badgeLabel}
              contrast="high-contrast"
            />
          </div>
        )}
        <div className="card-promo__text-content">
          <span className="card-promo__text-content__title">{title}</span>
          {description && (
            <p className="card-promo__text-content__description">
              {description}
            </p>
          )}
        </div>
        {"ctaLabel" in props &&
          wrapper(
            <div>
              <Button
                theme="primary-inverse"
                squared
                variant="default"
                onClick={"onCtaClick" in props ? props.onCtaClick : undefined}
                size="md"
              >
                {props.ctaLabel}
              </Button>
            </div>,
          )}
      </div>
      {disclaimer && (
        <div className="card-promo__text-content__disclaimer">{disclaimer}</div>
      )}
    </>
  );
};

CardPromo.displayName = "CardPromo";

export default CardPromo;
